export default `<div style="height: 100%; display: flex; flex-direction: column; justify-content: space-between;">
                      <div>
                        <div style="font-size: 1.4rem; margin-bottom: 20px; text-align: center;">
                          <strong>Create Your Own Template</strong>
                        </div>

                        <div style="display: flex;justify-content: center;">
                          <ol style="width: 390px;">
                            <li style="margin-top: 4px">
                              Load PDF using
                              <strong class="btn btn-info">
                                Load Source PDF or Image
                              </strong>
                              button
                            </li>
                            <li style="margin-top: 4px">
                              Click on the
                              <strong class="btn btn-primary">
                                Add Object
                              </strong>
                              button
                            </li>
                            <li style="margin-top: 4px">Select area on PDF page</li>
                            <li style="margin-top: 4px">New field from rectangle will be created</li>
                            <li style="margin-top: 4px">
                              Click
                              <strong class="btn btn-warning">
                                Run Template
                              </strong>
                              to run and extract
                            </li>
                          </ol>
                        </div>
                      </div>

                      <div>
                        <strong>Quick Tip</strong>: try
                        <strong class="btn btn-primary">Add Object</strong>
                        -
                        <strong>
                          Add FIELD mapped from Virtual Grid
                        </strong>
                        to quickly map values to fields using visual layout.
                      </div>
                    </div>`